import type { FC } from 'react'
import FieldErrorList from '../FieldErrorList'

interface FieldErrorsProps {
  error: string[]
  identifier: string
}

const ProductTariffFieldErrors: FC<FieldErrorsProps> = ({ error, identifier }) => {
  return (
    <FieldErrorList>
      {error.map((err: string, index: number) => (
        <li key={`${identifier}_${index}`}>{err}</li>
      ))}
    </FieldErrorList>
  )
}

export default ProductTariffFieldErrors
